import React from "react";
import styled, { css } from "styled-components";
import { Experiment, Variant } from "react-split-testing";
import createTrackPageviewVariant from "src/analytics/track-pageview-variant";
import MetaData from "src/react/components/meta-data";
import metaData from "src/data/meta-data";
import { productCategories } from "src/data/product-categories";
import CallToAction from "src/react/components/call-to-action";
import CompanyBadges from "src/react/components/company-badges";
import { StickyContainer } from "react-sticky";
import { color } from "src/styles/variables";
import { LayoutWrapper } from "src/react/layout";
import Hero from "./components/hero";
import WhyCornerstone from "./components/why-cornerstone";
import Reviews from "./components/reviews";
import Promo from "./components/promo";
import MembersReviews from "./components/members-reviews";
import HowItWorks from "./components/how-it-works";
import Intro from "./components/intro";

const experimentName = "03-09-20_homepage-shaving-focus";
const trackPageviewVariant = createTrackPageviewVariant();

function Homepage() {
  return (
    <LayoutWrapper backgroundColor="white">
      <MetaData data={metaData.homepage}>
        <script type="application/ld+json">{smartTags}</script>
      </MetaData>
      <StickyContainer>
        <Experiment
          name={experimentName}
          onChoice={(experimentName, variantName) =>
            trackPageviewVariant({
              name: experimentName,
              activeVariantId: variantName,
            })
          }
        >
          <Variant name={`${experimentName}--control`}>
            <Hero />
            <ReviewsWrapper>
              <Reviews css={reviewStyles} />
            </ReviewsWrapper>
            <WhyCornerstone />
          </Variant>
          <Variant name={`${experimentName}--variant1`}>
            <Hero
              showHeroText={false}
              image="//images.ctfassets.net/itvcls9imtx8/40Vj7zkN4B0lX9wB2r50V6/82439045cec6b9d828976a9777e6e43b/hero-collage-compressed.jpg"
            />
            <Intro />
            <HowItWorks />
            <ReviewsWrapper
              css={`
                background-color: ${color.lightGrey};
              `}
            >
              <Reviews css={reviewStyles} />
            </ReviewsWrapper>
          </Variant>
        </Experiment>
        <Promo
          reverse={true}
          image="https://images.ctfassets.net/itvcls9imtx8/3gt6T3ae9tgBXaTKser2wb/91b63ddf3d675f281c058eddc48c489f/Bundel-3.jpg"
          title={productCategories.shaving.name}
          description={productCategories.shaving.description}
          buttonText={`Shop ${productCategories.shaving.name}`}
          buttonUrl={`/products/category/${productCategories.shaving.id}`}
        />
        <Promo
          height={357}
          floatingImage={true}
          backgroundColour={color.prelude}
          image="https://images.ctfassets.net/itvcls9imtx8/6uE3o7NCXC31OzesD0FHJ4/cd923eed3f6047c8656a8f790d7494de/Hair-Category.png"
          title={productCategories.hair.name}
          description={productCategories.hair.description}
          buttonText={`Shop ${productCategories.hair.name}`}
          buttonUrl={`/products/category/${productCategories.hair.id}`}
        />
        <Promo
          reverse={true}
          backgroundColour={color.azalea}
          image="https://images.ctfassets.net/itvcls9imtx8/5LhFcNG3FZrFT7VIqzT0Gw/05c88a07b7c846b988757bcdf9f1ede7/Banna.png"
          title={productCategories.sex.name}
          description={productCategories.sex.description}
          buttonText={`Shop ${productCategories.sex.name}`}
          buttonUrl={`/products/category/${productCategories.sex.id}`}
        />
        <Promo
          image="https://images.ctfassets.net/itvcls9imtx8/6VLxvI0ls57BfixUtIxM2g/c2216c69cfac6bcda5651e229becf9f4/Mint.png"
          title={productCategories.body.name}
          description={productCategories.body.description}
          buttonText={`Shop ${productCategories.body.name}`}
          buttonUrl={`/products/category/${productCategories.body.id}`}
        />
        <Promo
          reverse={true}
          floatingImage={true}
          backgroundColour={color.aquaIsland}
          image="https://images.ctfassets.net/itvcls9imtx8/5JC9iqJo3xyIpjR4xpt7pY/845014d1baea0bf45463415c2060a52e/Smiling.png"
          title={productCategories.mouth.name}
          description={productCategories.mouth.description}
          buttonText={`Shop ${productCategories.mouth.name}`}
          buttonUrl={`/products/category/${productCategories.mouth.id}`}
        />
        <CallToAction homepage />
        <MembersReviews />
        <CompanyBadges />
      </StickyContainer>
    </LayoutWrapper>
  );
}

export default Homepage;

const smartTags = `
  {
    "@context": "http://www.schema.org/",
    "@type": "Product",
    "name": "Cornerstone",
    "brand": {
      "@type": "Thing",
      "name": "Cornerstone"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.5",
      "reviewCount": "4234"
    }
  }
`;

const ReviewsWrapper = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  ${({ css }) => css}
`;

const reviewStyles = css`
  max-width: 900px;
`;
